<template>
    <section>
        <div class="top-option-block">
            <button :class="{ 'active': reportOption === 1 }" @click="setActiveOption(1)">ภาพรวมรายเดือน</button>
            <button :class="{ 'active': reportOption === 2 }" @click="setActiveOption(2)">ภาพรวมรายวัน</button>
            <button :class="{ 'active': reportOption === 3 }" @click="setActiveOption(3)">รายงานอื่นๆ</button>
        </div>
    </section>
</template>

<script>
export default {
    data() {
        return {
            reportOption: -1
        }
    },
    mounted() {
        this.setActiveOption(1);
    },
    methods: {
        setActiveOption(option) {
            this.reportOption = option;
            this.$emit('reportOption', option)
        }
    }
}
</script>